<template>
  <v-app class="container_tabledata" color="#fff">
    <v-card id="top_iot" elevation="0">
      <v-layout v-resize="onResize" column style="">
        <loadingTable v-if="!iotData" />
        <v-card v-if="iotData" class="ma-3 elevation-0 rounded-0" style="border: solid 1px #E0E0E0;">
          <v-toolbar elevation="0" class="pa-0" color="#f7f7f7" fixed dense>
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    style="border: solid 1px #e0e0e0;"
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPage)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list     style="border: solid 1px #e0e0e0;">
                <v-list-item @click="itemsPerPage = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 25"
                  ><v-list-item-title>25</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 50"
                  ><v-list-item-title>50</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage =100"
                  ><v-list-item-title>100</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu>
            <v-spacer style="width: 70%"></v-spacer>
            <v-text-field
            style="border: solid 1px #e0e0e0;"
              width="40"
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"

            ></v-text-field>
            
          </v-toolbar>
          <v-divider></v-divider>
          <v-data-table
            v-if="iotData"
            :search="showIOTData()"
            :headers="headers"
            style="margin-top: 0px"
            :items="iotData"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 rounded-0 dataTable desktopTable_iot"
            @page-count="pageCount = $event"
            @pagination="yourMethod"
          >
          <template  v-slot:header>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">No</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Vessel Name</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Company</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Group</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Device State</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Current GPIO Status</th>
        <th class="pa-0 pt-2 pl-1" style="text-align:left;color:#626364;font-size:0.9em;height:3em">Manage</th>
      </template>
            <template v-slot:item="row">
              <tr>
                <td width="2%" class="pa-0" style="white-space: nowrap;">
                  {{ row.item.index + 1 }}
                
                </td>
                <td width="15%" class="pa-0" style="white-space: nowrap">
                  {{ row.item.name }}
                </td>
                <td width="15%" class="pa-0" style="white-space: nowrap">
                  {{ row.item.pt_name }}
                </td>
                <td width="15%" class="pa-0" style="white-space: nowrap">
                  <div class="grouptxt" v-if="!row.item.pt_group">-</div>
                  <div v-if="row.item.pt_group">{{ row.item.pt_group }}</div>
                </td>
                <td
                width="14%"
                  v-if="row.item.ae3.on && row.item.ae3.off"
                  class="pa-0"
                  style="white-space: nowrap"
                >
                  <div class="devicestate">
                    <div>UP Since {{ row.item.ae3.on }}</div>
                    <div>DOWN at {{ row.item.ae3.off }}</div>
                  </div>
                </td>
                <td
                width="10%"
                  v-if="!row.item.ae3.on && !row.item.ae3.off"
                  class="pa-0"
                  style="white-space: nowrap"
                >
                  -
                </td>
                <td width="10%" class="pa-0" style="white-space: nowrap">
                  <div v-if="row.item.devices.isGpio == true" class="gpiostatus">
                    <v-icon> mdi-lightning-bolt </v-icon>
                    <p class="txtgpio">AC Power :</p>
                    <v-chip
                    text-color="white"
                      small
                      v-if="row.item.ae5 == null || row.item.ae5"
                      class="mt-4 elevation-0 ml-2"
                      color="green"
                      >PLUGGED</v-chip
                    >
                    <v-chip
                    text-color="white"
                      small
                      v-if="row.item.ae5 == false"
                      class="mt-4 elevation-0 ml-2 blink"
                      color="red"
                      >UNPLUGGED</v-chip
                    >
                  </div>
                </td>
                <td width="19%" class="pa-0" style="white-space: nowrap">
                  <v-btn
                    width="47%"
                    v-if="row.item.devices.isGpio == true"
                    dark
                    @click="(gpioopen = true), sendDataGP(row.item)"
                    color="primary"
                    role="button"
                    class="mr-1 elevation-0 rounded-0"
                    small
                    > GPIO
                    History</v-btn
                  >
                  <v-btn
                    width="45%"
                    @click="addrpm_executed(false),sendDataRPM(row.item.id, 'today')"
                    v-if="row.item.devices.rpm"
                    dark
                    color="#38C172"
                    role="button"
                    class="pa-1 elevation-0 rounded-0"
                    small
                    > RPM
                    Report</v-btn
                  >

                  <v-btn
                    width="45%"
                    @click="addrpm_executed(false),sendDataRPM(row.item.id, 'today')"
                    v-if="row.item.devices.iot"
                    dark
                    color="#38C172"
                    role="button"
                    class="pa-1 elevation-0 rounded-0"
                    small
                    > IoT
                    Report</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
          v-if="iotData"
            :search="showIOTData()"
            :headers="headers"
            style="margin-top: 0px"
            :items="iotData"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            :items-per-page="itemsPerPage"
            class="elevation-0 rounded-0 mobileTable_iot"
            @page-count="pageCount = $event"
            @pagination="yourMethod"
          ><template v-slot:item="row">
    
      <tr style="margin-top:0.4em;margin-bottom:0.4em" >
        <td style="border-bottom:none;text-align:center" >
        <v-card style="border: solid 1px #e0e0e0" class="elevation-0 rounded-0 ma-1" width="87vw">
          <v-toolbar
           dense
           class="elevation-0 rounded-0"
          >
            <v-toolbar-subtitle>{{row.item.index+1}}</v-toolbar-subtitle>
            <v-spacer></v-spacer>
           
                

          </v-toolbar>
          <v-divider></v-divider>
      <v-card-text>
              <table>
           
            <tr><td>Vessel Name</td><td>:</td><td>{{row.item.name}}</td></tr>
            <tr><td>Company</td><td>:</td><td>{{row.item.pt_name}}</td></tr>
            <tr><td>Group</td><td>:</td><td> <div class="grouptxt" v-if="!row.item.pt_group">-</div>
                  <div v-if="row.item.pt_group">{{ row.item.pt_group }}</div></td></tr>
            <tr><td>Device State</td><td></td><td
           
                  v-if="row.item.ae3.on && row.item.ae3.off"
              
                >
                  <div class="devicestate">
                    <div>UP Since {{ row.item.ae3.on }}</div>
                    <div>DOWN at {{ row.item.ae3.off }}</div>
                  </div>
                </td></tr>
                <tr><td>Current GPIO Status</td><td>:</td><td>
                  <div v-if="row.item.devices.isGpio == true" class="gpiostatus">
                    <v-icon> mdi-lightning-bolt </v-icon>
                    <p class="txtgpio">AC Power :</p>
                    <v-chip
                    text-color="white"
                      small
                      v-if="row.item.ae5 == null || row.item.ae5"
                      class="mt-4 elevation-0 ml-2"
                      color="green"
                      >PLUGGED</v-chip
                    >
                    <v-chip
                    text-color="white"
                      small
                      v-if="row.item.ae5 == false"
                      class="mt-4 elevation-0 ml-2 blink"
                      color="red"
                      >UNPLUGGED</v-chip
                    >
                  </div>
                </td></tr>
            <tr><td colspan="3"><v-divider></v-divider></td></tr>
            <tr><td  colspan="3" class="pa-1"> 

              <v-btn
                   
                    v-if="row.item.devices.isGpio == true"
                    dark
                    @click="(gpioopen = true), sendDataGP(row.item)"
                    color="primary"
                    role="button"
                    class="mr-1 elevation-0 rounded-0"
                    small
                    > GPIO
                    History</v-btn
                  >
                  <v-btn
                   
                    @click="addrpm_executed(false),sendDataRPM(row.item.id, 'today')"
                    v-if="row.item.devices.rpm"
                    dark
                    color="#38C172"
                    role="button"
                    class="pa-1 elevation-0 rounded-0"
                    small
                    > RPM
                    Report</v-btn
                  >

                  <v-btn
                  
                    @click="addrpm_executed(false),sendDataRPM(row.item.id, 'today')"
                    v-if="row.item.devices.iot"
                    dark
                    color="#38C172"
                    role="button"
                    class="pa-1 elevation-0 rounded-0"
                    small
                    > IoT
                    Report</v-btn
                  ></td></tr>
       
        
            
          </table>
            </v-card-text>
          </v-card>
          
          
          
        </td>
      </tr>
   
  </template></v-data-table>
          <v-divider></v-divider>
          <v-toolbar  dense class="elevation-0 rounded-0" color="#f7f7f7">

<p class="mt-3" style="font-size:0.8em"> Showing {{showingDatafrom}} to {{ showingDatato }} of
              {{totalFilter}} entries</p>
<v-spacer></v-spacer>
<v-pagination
            class="pt-2 pb-2"
              v-model="page"
              color="primary"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
</v-toolbar>
          
        
        </v-card>
      </v-layout>
      <div id="bottom_table_iot"></div>
    </v-card>
    <!--Modal iot-->
    <v-dialog class="elevation-0 rounded-0" v-model="gpioopen" width="800px">
      <v-card class="elevation-0 rounded-0 pb-1">
        <v-toolbar  class="elevation-0 rounded-0" color="#f7f7f7" dense >
          <v-col class="header_modal">
            <v-row
              ><v-toolbar-title
                >IOT History for AC Power Plugged/Unplugged</v-toolbar-title
              ></v-row
            >
          </v-col>

          <v-spacer></v-spacer>

          <v-btn small class="elevation-0 rounded-0" icon @click="(notifopen = false), delGPIO()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-toolbar v-if="dataGPIO" class="elevation-0 rounded-0" color="#FFFF" dense>
          <v-toolbar-subtitle >{{
            dataGPIO.vessel_number
          }}</v-toolbar-subtitle>

          <v-spacer></v-spacer>
        </v-toolbar>
        <v-divider v-if="dataGPIO"></v-divider>
        <v-container style="margin-top:0" v-if="!dataGPIO" fill-height fluid>
          <v-row align="center" justify="center">
            <v-col
              ><img
                alt="Navplus logo"
                width="70px"
                :src="loadernavplus"
                class="justify-center"
            /></v-col>
          </v-row>
        </v-container>
        <v-card style="border: solid 1px #E0E0E0;" class="elevation-0 rounded-0 ma-3 " v-if="dataGPIO">
          <v-toolbar elevation="0" class="pa-0" color="#f7f7f7" fixed dense>
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                style="border: solid 1px #e0e0e0"
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPageGPIO)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item @click="itemsPerPageGPIO = 5"
                  ><v-list-item-title>5</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageGPIO = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageGPIO = 15"
                  ><v-list-item-title>15</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPageGPIO = Output.length"
                  ><v-list-item-title>All</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu>
            <v-spacer style="width: 70%"></v-spacer>
            
            <v-text-field
            style="border: solid 1px #e0e0e0;"
              width="40"
              v-model="searchGPIO"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
             
            ></v-text-field>
        
            
          </v-toolbar>
           <v-divider></v-divider>
            <v-data-table
              style="margin-top: 0px"
              :headers="headersGPIO"
              :items="Output"
              hide-default-footer
            :page.sync="pageGPIO"
            :items-per-page="itemsPerPageGPIO"
            class="elevation-0 rounded-0 dataTable"
            @page-count="pageCountGPIO = $event"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.index + 1 }}</td>
                  <td>{{ row.item.type }}</td>
                  <td> 
                  
                    <v-chip
                      small
                      v-if=" row.item.status == true && row.item.label == 'PLUGGED'"
                      class="mt-4 elevation-0 ml-2"
                      color="green"
                      text-color="white"
                      >{{row.item.label}}</v-chip
                    >
                    <v-chip
                      small
                      v-if=" row.item.status == false && row.item.label == 'UNPLUGGED'"
                      class="mt-4 elevation-0 ml-2"
                      text-color="white"
                      color="red"
                      >{{row.item.label}}</v-chip
                    >
                 </td>
                  <td>{{ row.item.dateTime_local }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-divider></v-divider>
            <v-toolbar
          
          dense
          class="elevation-0 rounded-0"
          color="#F7F7F7"
        >
          <p class="mt-3" style="font-size: 0.8em">
            Showing {{showingDatafrom}} to {{ showingDatato }} of
            {{totalFilter}} entries
          </p>
          <v-spacer></v-spacer>
          <v-pagination
              v-model="pageGPIO"
              color="primary"
              :length="pageCountGPIO"
              :total-visible="7"
            ></v-pagination>
        </v-toolbar>
            
        </v-card>
      </v-card>
    </v-dialog>
   
    <!--Modal IOT End-->
    <RpmShowSkeleton v-if="!rpmData && rpmShow"/>
    <RpmShowVue v-if="rpmData" />
  </v-app>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import * as easings from "vuetify/lib/services/goto/easing-patterns";
import RpmShowVue from "@/components/showpage/RpmShow.vue";
import { mapGetters, mapActions } from "vuex";
import loadingTable from "@/components/progress/loadingTable.vue";
import RpmShowSkeleton from "@/components/skeleton/RpmShowSkeleton.vue"

// import ModalSkeleton from '@/components/modal/ModalSkeleton.vue'
export default {
  components: {
    RpmShowVue,
    loadingTable,
    RpmShowSkeleton
    // ModalSkeleton
  },
  data() {
    return {
      headersGPIO: [
        {
          text: "#",
          align: "start",
          sortable: false,
        },
        { text: "GPIO Type", value: "index", sortable: false },
        { text: "Status", value: "type", sortable: false },
        { text: "dateTime(GMT+7)", value: "dateTime_local", sortable: false },
      ],
      rpmshowclick: false,
      gpioopen: false,
      dataGPIO: null,
      rpmOutput: null,
      itemsPerPage: 10,
      page: 1,
      searchGPIO: null,
      pageCount: 0,
      itemsPerPageGPIO: 10,
      pageGPIO: 1,
      pageCountGPIO: 0,
      Output: null,
      headers: [
        {
          text: "No",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Vessel Name", value: "name" },
        { text: "Company", value: "pt_name" },
        { text: "Group", value: "pt_group" },
        { text: "Device State", value: "ae3" },
        { text: "Current GPIO Status", value: "ae5" },
        { text: "Manage", value: "rpm_search" },
      ],
      // in real case initial search_result = [], and methods: search function inject below data
      iot: null,
      selectedItem: "",
      selectedNotif: "",
      search: "",
      showmaptable: "",
      index: "",
      loadernavplus: require("@/assets/img/load100new.gif"),
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
      easings: Object.keys(easings),
      totalFilter:null
    };
  },
  async created() {
    this.fetchIot(localStorage.getItem("token"));
    if (this.rpmreportID) {
      this.sendDataRPM(this.rpmreportID, "today");
    }
  },

  mounted() {
    this.$root.$on("sendDataRPM", (id, range) => {
      this.sendDataRPM(id, range);
    });
  },

  methods: {
    ...mapActions(["fetchIot", "fetchRpm", "removeSearchIOT","removeRpmShow","addrpm_executed"]),
    delGPIO() {
      this.gpioopen = false;
      this.dataGPIO = null;
    },

    yourMethod(pagination) {
      this.totalFilter = pagination.itemsLength

  },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },

    nulsearch() {
      this.removeSearchIOT();
    },

    showIOTData() {
      if (this.searchIOT) {
        return this.searchIOT;
      } else {
        return this.search;
      }
    },

    async sendDataRPM(id, range) {
      console.log("JALANIN INI");
      $('html, body').animate({
        scrollTop: $("#bottom_table_iot").offset().top
    }, 1000);
      this.removeRpmShow();
      console.log(id);
      // this.$vuetify.goTo(this.target, this.options);
      const data = {
        id: id,
        range: range,
        token: localStorage.getItem("token"),
      };
      this.fetchRpm(data);

     
    },

    async sendDataGP(item) {
      const response = await axios.get(
        "https://navigatorplus.sailink.id/api/v1/navplus/iot/" + item.id,
        {
          headers: {
            Authorization: "Bearer" + localStorage.getItem("token"),
          },
        }
      );
      console.log(response);
      this.dataGPIO = response.data.data;
      this.Output = this.dataGPIO.output.map((item, index) =>
        Object.assign(item, { index })
      );
    },

    async sendDataNotif(item) {
      const response = await axios.get(
        "https://navigatorplus.sailink.id/api/v1/navplus/sailink/mrtg/" +
          item.id +
          "/" +
          item.mrtg_id,
        {
          headers: {
            Authorization: "Bearer" + localStorage.getItem("token"),
          },
        }
      );
      this.selectedNotif = response.data.data;
    },
  },
  computed: {
    ...mapGetters(["iotData", "rpmreportID", "searchIOT","rpmShow","rpmData"]),
    target() {
      return 62000000;
    },
    options() {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
    },

    showingDatafrom(){
      if( this.totalFilter < 1 ){
        return 0
      }else{
       return 1
      }
        
    },
   
    showingDatato(){
      if( this.totalFilter < this.itemsPerPage ){
        return this.totalFilter
      }else{
       return this.itemsPerPage
      }
        
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/data.scss";
.gpiostatus {
  display: flex;
}
.txtgpio {
  margin-top: 15px;
}
.devicestate {
  display: block;
}
.blink {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}



@media (min-width: 280px) and (max-width: 319px) {
  .mobileTable_iot{
    display:block
  }
  .desktopTable_iot{
    display:none
  }
}

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  .mobileTable_iot{
    display:block
  }
  .desktopTable_iot{
    display:none
  }
}

/* iPads, Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .mobileTable_iot{
    display:none
  }
  .desktopTable_iot{
    display:block
  }
}

/* Small screens, laptops */
@media (min-width: 769px) and (max-width: 1024px) {
  .mobileTable_iot{
    display:none
  }
  .desktopTable_iot{
    display:block
  }
}

/* Desktops, large screens */
@media (min-width: 1025px) and (max-width: 1200px){
  .mobileTable_iot{
    display:none
  }
  .desktopTable_iot{
    display:block
  }
}

/* Extra large screens / TV */
@media screen and (min-width: 1201px) {
  .mobileTable_iot{
    display:none
  }
  .desktopTable_iot{
    display:block
  }


}
</style>
